'use client'

import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Plus,
  Edit,
  Trash2,
  CheckCircle,
  DollarSign,
  Calendar,
  MinusCircle,
  Phone
} from 'lucide-react'
import Modal from 'react-modal'
import { BackupButton } from './generatePdf'

Modal.setAppElement('#root')

const Emprestimo = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)

  const [isEditModal2Open, setIsEditModal2Open] = useState(false)

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
  const [emprestimos, setEmprestimos] = useState([])
  const [clientes, setClientes] = useState([])
  const navigate = useNavigate()
  const [isClientModalOpen, setIsClientModalOpen] = useState(false)
  const [newClientName, setNewClientName] = useState('')
  const [clientMessage, setClientMessage] = useState('')
  const [formData, setFormData] = useState({
    nome: '',
    valor: '',
    juros: '',
    valor_jurosdiarios: 0,
    dataPagamento: '',
    meses: '',

    idUsuario: localStorage.getItem('idUsuario'),
    // idCliente adicionado para garantir filtro preciso dos empréstimos
    idCliente: localStorage.getItem('idCliente'),
    telefone: ''
  })
  const [editData, setEditData] = useState({
    id: null,
    nome: '',
    valor: '',
    juros: '',
    valor_jurosdiarios: 0,
    dataPagamento: '',
    telefone: '',
    idCliente: null
  })
  const [emprestimoId, setEmprestimoId] = useState(null)
  const [deleteId, setDeleteId] = useState(null)

  useEffect(() => {
    const idUsuario = localStorage.getItem('idUsuario')
    const idCliente = localStorage.getItem('idCliente')
    // Se idCliente estiver disponível, já incluir no querystring
    const url = `https://sismoney.com/painel/database_resumo.php?idUsuario=${idUsuario}${
      idCliente ? `&idCliente=${idCliente}` : ''
    }`

    fetch(url)
      .then(response => response.json())
      .then(data => {
        console.log('Dados recebidos:', data)
        // Novo formato: { emprestimos: [...], clientes: [...] }
        if (
          data &&
          Array.isArray(data.emprestimos) &&
          Array.isArray(data.clientes)
        ) {
          setEmprestimos(data.emprestimos)
          // normalizar nomes, remover vazios e duplicados (case-insensitive)
          const cleaned = []
          const seen = new Set()
          data.clientes.forEach(c => {
            const nome = (c.nome || '').toString().trim()
            if (!nome) return
            const key = nome.toLowerCase()
            if (seen.has(key)) return
            seen.add(key)
            cleaned.push({ ...c, nome })
          })
          setClientes(cleaned)
          return
        }

        // Compatibilidade: resposta antiga como array de empréstimos
        if (Array.isArray(data)) {
          if (idCliente) {
            const filtered = data.filter(
              item => String(item.idCliente) === String(idCliente)
            )
            setEmprestimos(filtered)
          } else {
            setEmprestimos(data)
          }
          return
        }

        console.error(
          'Resposta da API inesperada ao carregar empréstimos/clientes',
          data
        )
      })
      .catch(error => console.error('Erro ao carregar empréstimos:', error))
  }, [])

  // Carrega clientes do usuário (função reutilizável)
  const loadClientes = async () => {
    const idUsuario = localStorage.getItem('idUsuario')
    try {
      const res = await fetch(
        `https://sismoney.com/painel/database_resumo.php?idUsuario=${idUsuario}`
      )
      const data = await res.json()
      // esperar formato { emprestimos, clientes }
      if (data && Array.isArray(data.clientes)) {
        const cleaned = []
        const seen = new Set()
        data.clientes.forEach(c => {
          const nome = (c.nome || '').toString().trim()
          if (!nome) return
          const key = nome.toLowerCase()
          if (seen.has(key)) return
          seen.add(key)
          cleaned.push({ ...c, nome })
        })
        setClientes(cleaned)
      } else if (Array.isArray(data)) {
        const cleaned = []
        const seen = new Set()
        data.forEach(c => {
          const nome = (c.nome || '').toString().trim()
          if (!nome) return
          const key = nome.toLowerCase()
          if (seen.has(key)) return
          seen.add(key)
          cleaned.push({ ...c, nome })
        })
        setClientes(cleaned)
      } else {
        console.error('Resposta da API de clientes não é um array', data)
      }
    } catch (err) {
      console.error('Erro ao carregar clientes:', err)
    }
  }

  // Não carregamos clientes separadamente no mount mais — agora esperamos que o
  // endpoint `database_resumo.php` retorne `clientes` junto com `emprestimos`.
  // Mantemos `loadClientes()` como fallback para operações específicas.

  const handleAddClient = async e => {
    e && e.preventDefault()
    setClientMessage('')
    const idUsuario = localStorage.getItem('idUsuario')
    const nomeTrim = (newClientName || '').trim()
    if (!nomeTrim) {
      setClientMessage('Informe o nome do cliente')
      return
    }
    // validar duplicado (case-insensitive)
    const exists = clientes.some(
      c => c.nome && c.nome.toLowerCase() === nomeTrim.toLowerCase()
    )
    if (exists) {
      setClientMessage('Já existe um cliente com esse nome')
      return
    }
    try {
      // Unifica criação em database_resumo.php com resource='cliente'
      const res = await fetch(
        'https://sismoney.com/painel/database_resumo.php',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            resource: 'cliente',
            nome: nomeTrim,
            idUsuario
          })
        }
      )
      const result = await res.json()
      if (result.success) {
        setNewClientName('')
        setIsClientModalOpen(false)
        // recarregar clientes via o endpoint unificado
        await loadClientes()
        // selecionar automaticamente o cliente criado, se retornou id
        if (result.id) {
          setFormData(prev => ({
            ...prev,
            idCliente: result.id,
            nome: result.nome || nomeTrim
          }))
        } else {
          // fallback: procurar pelo nome na lista recarregada
          const found = clientes.find(
            c => c.nome && c.nome.toLowerCase() === nomeTrim.toLowerCase()
          )
          if (found)
            setFormData(prev => ({
              ...prev,
              idCliente: found.id,
              nome: found.nome
            }))
        }
      } else {
        setClientMessage(result.message || 'Erro ao cadastrar cliente')
      }
    } catch (err) {
      console.error('Erro ao cadastrar cliente:', err)
      setClientMessage('Erro ao cadastrar cliente')
    }
  }

  const handleOpenModal = () => setIsModalOpen(true)
  const handleCloseModal = () => setIsModalOpen(false)

  const handleOpenEditModal = emprestimo => {
    setEditData({
      id: emprestimo.id,
      nome: emprestimo.nome,
      valor: emprestimo.valor,
      juros: emprestimo.juros,
      valor_jurosdiarios: emprestimo.valor_jurosdiarios,
      // preencher idCliente ao abrir modal de edição
      idCliente: emprestimo.idCliente || localStorage.getItem('idCliente'),
      telefone: emprestimo.telefone,
      dataPagamento: emprestimo.dataPagamento
    })
    setIsEditModalOpen(true)
  }

  const handleOpenEdit2Modal = emprestimo => {
    setEditData({
      id: emprestimo.id,
      nome: emprestimo.nome,
      valor: emprestimo.valor,
      valor_jurosdiarios: emprestimo.valor_jurosdiarios,

      juros: emprestimo.juros,
      idCliente: emprestimo.idCliente || localStorage.getItem('idCliente'),
      telefone: emprestimo.telefone,
      dataPagamento: emprestimo.dataPagamento
    })
    setIsEditModal2Open(true)
  }
  const handleCloseEditModal = () => {
    setIsEditModalOpen(false)
    setEditData({
      id: null,
      nome: '',
      valor: '',
      juros: '',
      dataPagamento: '',
      valor_jurosdiarios: 0,
      telefone: ''
    })
  }
  const handleCloseEdit2Modal = () => {
    setIsEditModal2Open(false)
    setEditData({
      id: null,
      nome: '',
      valor: '',
      juros: '',
      dataPagamento: '',
      valor_jurosdiarios: 0,
      telefone: ''
    })
  }

  const handleOpenDeleteModal = id => {
    setDeleteId(id)
    setIsDeleteModalOpen(true)
  }

  const handleCloseDeleteModal = () => {
    setDeleteId(null)
    setIsDeleteModalOpen(false)
  }

  const handleOpenConfirmModal = id => {
    setEmprestimoId(id)
    setIsConfirmModalOpen(true)
  }

  const handleCloseConfirmModal = () => {
    setEmprestimoId(null)
    setIsConfirmModalOpen(false)
  }

  const handleInputChange = e => {
    const { name, value } = e.target
    console.log(`Campo alterado: ${name}, Novo valor: ${value}`)
    // Se o campo for idCliente, ajusta também o nome do cliente no formData
    if (name === 'idCliente') {
      const cliente = clientes.find(c => String(c.id) === String(value))
      setFormData(prevData => ({
        ...prevData,
        idCliente: value,
        nome: cliente ? cliente.nome : prevData.nome
      }))
      return
    }
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }))
  }

  const handleEditInputChange = e => {
    const { name, value } = e.target
    setEditData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async e => {
    e.preventDefault()
    try {
      const response = await fetch(
        'https://sismoney.com/painel/database_resumo.php',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        }
      )
      const result = await response.json()
      if (result.success) {
        setEmprestimos(prev => [...prev, { ...formData }])
        handleCloseModal()
        window.location.reload()
      } else {
        console.error('Erro ao registrar o empréstimo:', result.message)
      }
    } catch (error) {
      console.error('Erro na requisição:', error)
    }
  }

  const handleSaveEdit = async editar => {
    try {
      const url = editar
        ? 'https://sismoney.com/painel/database_resumo.php?editar=true'
        : 'https://sismoney.com/painel/database_resumo.php'

      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(editData)
      })

      const result = await response.json()
      console.log(editData)
      if (result.success) {
        // Atualiza a lista de empréstimos com os novos dados
        setEmprestimos(prev =>
          prev.map(emprestimo =>
            emprestimo.id === editData.id
              ? { ...emprestimo, ...editData }
              : emprestimo
          )
        )
        handleCloseEditModal()
        window.location.reload()
      } else {
        console.error('Erro ao salvar edição:', result.message)
      }
    } catch (error) {
      console.error('Erro na requisição de edição:', error)
    }
  }

  const handleDelete = async id => {
    try {
      const response = await fetch(
        `https://sismoney.com/painel/database_resumo.php?id=${id}`,
        {
          method: 'DELETE'
        }
      )
      const result = await response.json()
      if (result.success) {
        setEmprestimos(prev => prev.filter(emprestimo => emprestimo.id !== id))
        handleCloseDeleteModal()
        window.location.reload()
      } else {
        console.error('Erro ao excluir empréstimo:', result.message)
      }
    } catch (error) {
      console.error('Erro na requisição de exclusão:', error)
    }
  }

  const togglePago = async id => {
    try {
      const response = await fetch(
        'https://sismoney.com/painel/database_resumo.php',
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: id,
            status: 'pendente'
          })
        }
      )
      const result = await response.json()
      if (result.success) {
        setEmprestimos(prev =>
          prev.map(emprestimo =>
            emprestimo.id === id
              ? { ...emprestimo, status: 'Pago' }
              : emprestimo
          )
        )
        handleCloseConfirmModal()
        window.location.reload()
      } else {
        console.error(
          'Erro ao atualizar status de pagamento do empréstimo:',
          result.message
        )
      }
    } catch (error) {
      console.error(
        'Erro ao alternar status de pagamento do empréstimo:',
        error
      )
    }
  }

  const isAtrasado = dataPagamento => {
    const today = new Date()
    const pagamentoDate = new Date(dataPagamento)
    return pagamentoDate < today
  }

  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      borderRadius: '8px',
      padding: '20px',
      maxWidth: '500px',
      width: '100%'
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.75)'
    }
  }

  return (
    <div className="space-y-6">
      {/* Link para rota de Clientes */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div>
            <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
              Módulo de Empréstimo
            </h2>
            <p className="text-gray-600 dark:text-gray-400">
              Gerencie seus empréstimos aqui.
            </p>
          </div>
          <button
            onClick={() => navigate('/clientes')}
            className="ml-2 text-sm px-3 py-1 bg-gray-200 dark:bg-gray-700 rounded-md"
            title="Ir para clientes"
          >
            Clientes
          </button>
        </div>
        <div className="flex space-x-2">
          <button
            onClick={handleOpenModal}
            className="flex items-center px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
          >
            <Plus className="w-5 h-5 mr-2" />
            Adicionar empréstimo
          </button>
          <BackupButton emprestimos={emprestimos} />
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 transition-colors duration-200">
        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-4">
          Lista de Empréstimos
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Nome
                </th>
                <th scope="col" className="px-6 py-3">
                  Valor
                </th>
                <th scope="col" className="px-6 py-3">
                  Juros
                </th>
                <th scope="col" className="px-6 py-3">
                  A receber
                </th>
                <th scope="col" className="px-6 py-3">
                  Juros diários
                </th>
                <th scope="col" className="px-6 py-3">
                  Data de Pagamento
                </th>
                <th scope="col" className="px-6 py-3">
                  Telefone
                </th>
                <th scope="col" className="px-6 py-3">
                  Status
                </th>
                <th scope="col" className="px-6 py-3">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody>
              {emprestimos.map(emprestimo => (
                <tr
                  key={emprestimo.id}
                  className={`${
                    isAtrasado(emprestimo.dataPagamento)
                      ? 'bg-red-100 dark:bg-red-900/20'
                      : 'bg-white dark:bg-gray-800'
                  } border-b dark:border-gray-700`}
                >
                  <td className="px-6 py-4 font-medium text-gray-900 dark:text-white">
                    {emprestimo.nome}
                  </td>
                  <td className="px-6 py-4">
                    R${' '}
                    {Number(emprestimo.valor).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </td>
                  <td className="px-6 py-4">{emprestimo.juros}%</td>
                  <td className="px-6 py-4">
                    {(() => {
                      const valor = Number(emprestimo.valor) || 0
                      const valorJurosDiarios = Number(
                        emprestimo.valor_jurosdiarios || 0
                      )
                      const dataPgto = emprestimo.dataPagamento
                        ? new Date(emprestimo.dataPagamento)
                        : null
                      const hoje = new Date()

                      const baseSurcharge =
                        valor * (emprestimo.juros / 100) - valor

                      let diasAtraso = 0
                      if (dataPgto && dataPgto < hoje) {
                        const diffTime =
                          hoje.setHours(0, 0, 0, 0) -
                          dataPgto.setHours(0, 0, 0, 0)
                        diasAtraso = Math.floor(
                          diffTime / (1000 * 60 * 60 * 24)
                        )
                      }

                      // Para cada mês completo de atraso, aplicar +30% adicional
                      const mesesCompletos = Math.floor(diasAtraso / 30)
                      const additionalMonthsPercent = mesesCompletos * 0.3

                      const jurosDiariosTotal = diasAtraso * valorJurosDiarios

                      const aReceber =
                        valor +
                        baseSurcharge +
                        valor * additionalMonthsPercent +
                        (diasAtraso > 0 ? jurosDiariosTotal : 0)

                      return `R$ ${Number(aReceber).toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}`
                    })()}
                  </td>
                  <td className="px-6 py-4">
                    {(() => {
                      const valorJurosDiarios = Number(
                        emprestimo.valor_jurosdiarios || 0
                      )
                      const dataPgto = emprestimo.dataPagamento
                        ? new Date(emprestimo.dataPagamento)
                        : null
                      const hoje = new Date()
                      if (dataPgto && dataPgto < hoje) {
                        const diffTime =
                          hoje.setHours(0, 0, 0, 0) -
                          dataPgto.setHours(0, 0, 0, 0)
                        const diasAtraso = Math.floor(
                          diffTime / (1000 * 60 * 60 * 24)
                        )
                        const total = diasAtraso * valorJurosDiarios
                        return `R$ ${Number(total).toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })} (${diasAtraso} dias)`
                      }
                      return 'Em dia'
                    })()}
                  </td>
                  <td className="px-6 py-4">
                    <div>
                      {String(
                        new Date(emprestimo.dataPagamento).getUTCDate()
                      ).padStart(2, '0')}
                      /
                      {String(
                        new Date(emprestimo.dataPagamento).getUTCMonth() + 1
                      ).padStart(2, '0')}
                      /{new Date(emprestimo.dataPagamento).getUTCFullYear()}
                    </div>
                  </td>
                  <td className="px-6 py-4">{emprestimo.telefone}</td>

                  <td className="px-6 py-4">{emprestimo.status}</td>
                  <td className="px-6 py-4 space-x-2">
                    <button
                      onClick={() => handleOpenConfirmModal(emprestimo.id)}
                      className="text-green-600 hover:text-green-900 dark:hover:text-green-400"
                    >
                      <CheckCircle className="w-5 h-5" />
                    </button>

                    <button
                      onClick={() => handleOpenEdit2Modal(emprestimo)}
                      className="text-indigo-600 hover:text-indigo-900 dark:hover:text-indigo-400 "
                    >
                      <MinusCircle className="w-5 h-5" />
                    </button>

                    <button
                      onClick={() => handleOpenEditModal(emprestimo)}
                      className="text-indigo-600 hover:text-indigo-900 dark:hover:text-indigo-400"
                    >
                      <Edit className="w-5 h-5" />
                    </button>

                    <button
                      onClick={() => handleOpenDeleteModal(emprestimo.id)}
                      className="text-red-600 hover:text-red-900 dark:hover:text-red-400"
                    >
                      <Trash2 className="w-5 h-5" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        style={customModalStyles}
        contentLabel="Cadastro de Empréstimo"
      >
        <h2 className="text-2xl font-bold mb-4">Cadastro de Empréstimo</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Cliente
            </label>
            <div className="mt-1 flex gap-2 items-center">
              <select
                name="idCliente"
                value={formData.idCliente || ''}
                onChange={handleInputChange}
                required
                className="block w-full rounded-md border-gray-300 shadow-sm pl-3 pr-3 py-2 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
              >
                <option value="">Selecione um cliente</option>
                {clientes.map(c => (
                  <option key={c.id} value={c.id}>
                    {c.nome}
                  </option>
                ))}
              </select>
              <button
                type="button"
                onClick={() => setIsClientModalOpen(true)}
                className="px-3 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
              >
                Cadastrar cliente
              </button>
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Valor
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <DollarSign className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="number"
                name="valor"
                value={formData.valor}
                onChange={handleInputChange}
                required
                className="block w-full pl-10 pr-12 sm:text-sm border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Juros (%)
            </label>
            <input
              type="number"
              name="juros"
              value={formData.juros}
              onChange={handleInputChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Valor Juros Diários (R$)
            </label>
            <input
              type="number"
              name="valor_jurosdiarios"
              value={formData.valor_jurosdiarios}
              onChange={handleInputChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Telefone
            </label>
            <input
              type="text"
              name="telefone"
              value={formData.telefone}
              onChange={handleInputChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Data de Pagamento
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Calendar className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="date"
                name="dataPagamento"
                value={formData.dataPagamento}
                onChange={handleInputChange}
                required
                className="block w-full pl-10 pr-12 sm:text-sm border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </div>
          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={handleCloseModal}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
            >
              Salvar
            </button>
          </div>
        </form>
      </Modal>

      {/* Modal para cadastrar cliente */}
      <Modal
        isOpen={isClientModalOpen}
        onRequestClose={() => setIsClientModalOpen(false)}
        style={customModalStyles}
        contentLabel="Cadastro de Cliente"
      >
        <h2 className="text-2xl font-bold mb-4">Cadastro de Cliente</h2>
        <form onSubmit={handleAddClient} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Nome
            </label>
            <input
              type="text"
              value={newClientName}
              onChange={e => setNewClientName(e.target.value)}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
            {clientMessage && (
              <p className="text-sm text-red-600 mt-2">{clientMessage}</p>
            )}
          </div>
          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={() => setIsClientModalOpen(false)}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
            >
              Salvar
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        isOpen={isEditModal2Open}
        onRequestClose={handleCloseEdit2Modal}
        style={customModalStyles}
        contentLabel="Editar Empréstimo"
      >
        <h2 className="text-2xl font-bold mb-4">Abatimento VALOR </h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Valor
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <DollarSign className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="number"
                name="valor"
                onChange={handleEditInputChange}
                placeholder="Valor a ser ABATIDO"
                required
                className="block w-full pl-10 pr-12 sm:text-sm border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Juros (%)
            </label>
            <input
              type="number"
              name="juros"
              value={editData.juros}
              onChange={handleEditInputChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Valor Juros Diários (R$)
            </label>
            <input
              type="number"
              name="valor_jurosdiarios"
              value={editData.valor_jurosdiarios}
              onChange={handleEditInputChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Telefone
            </label>
            <input
              type="text"
              name="telefone"
              value={editData.telefone}
              onChange={handleEditInputChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Data de Pagamento
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Calendar className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="date"
                name="dataPagamento"
                value={editData.dataPagamento}
                onChange={handleEditInputChange}
                required
                className="block w-full pl-10 pr-12 sm:text-sm border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </div>
          <div className="flex justify-end space-x-3 pt-4">
            <button
              onClick={handleCloseEdit2Modal}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Cancelar
            </button>
            <button
              onClick={() => {
                handleSaveEdit(false)
              }}
              className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
            >
              Salvar
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={handleCloseEditModal}
        style={customModalStyles}
        contentLabel="Editar Empréstimo"
      >
        <h2 className="text-2xl font-bold mb-4">Edição empréstimo </h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Nome
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Edit className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="text"
                name="nome"
                value={editData.nome}
                onChange={handleEditInputChange}
                placeholder="Nome"
                required
                className="block w-full pl-10 pr-12 sm:text-sm border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Valor
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <DollarSign className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="number"
                name="valor"
                onChange={handleEditInputChange}
                placeholder="Valor a ser alterado ( NÃO É ABATIMENTO )"
                required
                className="block w-full pl-10 pr-12 sm:text-sm border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Juros (%)
            </label>
            <input
              type="number"
              name="juros"
              value={editData.juros}
              onChange={handleEditInputChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Valor Juros Diarios (R$)
            </label>
            <input
              type="number"
              name="valor_jurosdiarios"
              value={editData.valor_jurosdiarios}
              onChange={handleEditInputChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Telefone
            </label>
            <input
              type="text"
              name="telefone"
              value={editData.telefone}
              onChange={handleEditInputChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Data de Pagamento
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Calendar className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="date"
                name="dataPagamento"
                value={editData.dataPagamento}
                onChange={handleEditInputChange}
                required
                className="block w-full pl-10 pr-12 sm:text-sm border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </div>
          <div className="flex justify-end space-x-3 pt-4">
            <button
              onClick={handleCloseEditModal}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Cancelar
            </button>
            <button
              onClick={() => {
                handleSaveEdit(true)
              }}
              className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
            >
              Salvar
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={handleCloseDeleteModal}
        style={customModalStyles}
        contentLabel="Confirmação de Exclusão"
      >
        <h2 className="text-2xl font-bold mb-4">Confirmação</h2>
        <p className="mb-4">
          Você tem certeza que deseja excluir este item? Essa ação não pode ser
          desfeita.
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => handleDelete(deleteId)}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
          >
            Sim, excluir
          </button>
          <button
            onClick={handleCloseDeleteModal}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Cancelar
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={isConfirmModalOpen}
        onRequestClose={handleCloseConfirmModal}
        style={customModalStyles}
        contentLabel="Confirmação de Pagamento"
      >
        <h2 className="text-2xl font-bold mb-4">Confirmação</h2>
        <p className="mb-4">
          Você tem certeza que deseja marcar o juros do mês como pago?
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => togglePago(emprestimoId)}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            Sim, marcar como pago
          </button>
          <button
            onClick={handleCloseConfirmModal}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Cancelar
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default Emprestimo
